import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-quem-somos',
  templateUrl: './quem-somos.component.html',
  styleUrls: ['./quem-somos.component.scss'],
})
export class QuemSomosComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
